/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const sendInterviewBookingMessageInputSchema = z.object({
	tokenIds: z.array(z.string()),
	deliveryChannels: z.array(z.union([z.literal('email'), z.literal('whatsapp')])),
	emailBody: z.string().nullable().optional(),
})

export type SendInterviewBookingMessageInputSchema = z.infer<typeof sendInterviewBookingMessageInputSchema>
